import { Component, Input } from '@angular/core';
import { ProvidersService } from 'fccore2';
import {  FCEVENT } from '../fc';
import { Sysappbuttons } from 'fccore2';
import { FcinputComponent } from '../fcinput';
/**
 * fc-buttonæé®
 * 
 * æé®ç¨äºå¼å§ä¸ä¸ªå³æ¶æä½ã
 * 
 * æ è®°äºä¸ä¸ªï¼æå°è£ä¸ç»ï¼æä½å½ä»¤ï¼ååºç¨æ·ç¹å»è¡ä¸ºï¼è§¦åç¸åºçä¸å¡é»	è¾ã
 * 
 * äºä»¶ï¼
 * 
 * 1.ç¹å»äºä»¶ï¼click
 * 
 */
@Component({
    selector: 'fc-button',
    template: `
    <button class="fc-button" *ngIf="fcMode!=='dropdown'&&fcMode!=='group'" [title]="fcToolTip||''"
        nz-button [nzType]="fcType" [nzSize]="fcSize" [nzShape]="fcShape" [nzLoading]="_load" [disabled]="_disabled" [style.background]="fcStyle"
        [ngClass]="{'fc-button-block':fcBlock === 'Y'}" [nzGhost]="_opacity">
        <i nz-icon [iconfont]="fcIcon"  *ngIf="fcIcon&&fcIconPositon===undefined"></i>
        <i nz-icon [iconfont]="fcIcon"  *ngIf="fcIcon&&fcIconPositon==='left'"></i>
        <span>{{fcLabel}}</span>
        <i nz-icon [iconfont]="fcIcon"  *ngIf="fcIcon&&fcIconPositon==='right'"></i>
    </button>
    <nz-dropdown *ngIf="fcMode==='dropdown'">
        <button class="fc-button" nz-button nz-dropdown [title]="fcToolTip||''"  [nzSize]="fcSize"
        [nzType]="fcType" [ngClass]="{'fc-button-block':fcBlock === 'Y'}" [nzGhost]="_opacity">
            <i nz-icon [iconfont]="fcIcon"  *ngIf="fcIcon&&fcIconPositon==='left'"></i>
            <span>{{fcLabel}}</span>
            <i nz-icon [iconfont]="fcIcon" *ngIf="fcIcon&&fcIconPositon==='right'"></i>
        </button>
        <ul nz-menu>
            <li nz-menu-item *ngFor="let item of fcDropdown">
                <a  (click)="_dropdownClick($event)">
                    <i nz-icon [iconfont]="item.icon" *ngIf="(item.icon!==''||item.icon!==undefined||item.icon!==null)&&(item.position===undefined||item.position===''||item.position==='left')"></i>
                    <span >{{item.label}}</span>
                    <i nz-icon [iconfont]="item.icon" *ngIf="(item.icon!==''||item.icon!==undefined||item.icon!==null)&&(item.position==='right')"></i>
                </a>
            </li>
        </ul>
    </nz-dropdown>
    <nz-button-group  *ngIf="fcMode==='group'&&_disableds===undefined" [nzSize]="fcSize">
        <button class="fc-button" *ngFor="let btn of fcGroup" nz-button
            [nzType]="btn.BTNCLASS" [nzSize]="fcSize" [nzShape]="fcShape" [nzLoading]="_load" [disabled]="_disabled" [style.background]="btn.fcStyle"
            [ngClass]="{'fc-button-block':fcBlock}" [nzGhost]="_opacity"  [title]="btn.HELP||btn.BTNNAME||''"
            (click)="event(btn.ACTCODE,btn)">
                <i nz-icon [iconfont]="btn.BTNICON" *ngIf="(btn.BTNICON!==''||btn.BTNICON!==undefined||btn.BTNICON!==null)&&(btn.POSITION===undefined||btn.POSITION===''||btn.POSITION==='left')"></i>
                <span>{{btn.BTNNAME}}</span>
                <i nz-icon [iconfont]="btn.BTNICON" *ngIf="(btn.BTNICON!==''||btn.BTNICON!==undefined||btn.BTNICON!==null)&&(btn.POSITION==='right')"></i>
        </button>
    </nz-button-group>
    <nz-button-group *ngIf="fcMode==='group'&&_disableds!==undefined" [nzSize]="fcSize">
        <button class="fc-button" *ngFor="let btn of fcGroup" nz-button
            [nzType]="btn.BTNCLASS" [nzSize]="fcSize" [nzShape]="fcShape" [nzLoading]="_load" [disabled]="_disabled" [style.background]="btn.fcStyle"
            [ngClass]="{'fc-button-block':fcBlock}" [nzGhost]="_opacity" [title]="btn.HELP||btn.BTNNAME||''"
            (click)="event(btn.ACTCODE,btn)" [disabled]="_disableds[btn.BTNCODE]">
                <i nz-icon [iconfont]="btn.BTNICON" *ngIf="(btn.BTNICON!==''||btn.BTNICON!==undefined||btn.BTNICON!==null)&&(btn.POSITION===undefined||btn.POSITION===''||btn.POSITION==='left')"></i>
                <span>{{btn.BTNNAME}}</span>
                <i nz-icon [iconfont]="btn.BTNICON" *ngIf="(btn.BTNICON!==''||btn.BTNICON!==undefined||btn.BTNICON!==null)&&(btn.POSITION==='right')"></i>
        </button>
    </nz-button-group>
    `,
    styles: [
        `
        .fc-button-block{
            width:100%;
            display:block;
        }
        .fc-button{

        }
        `
    ]
})
export class FcbuttonComponent extends FcinputComponent {
     /** åå®¹ */
    @Input()
    fcLabel: string;
     /** ç±»å */
    @Input()
    fcType: string;
     /**å½¢ç¶*/
    @Input()
    fcShape: string;
     /**å¾æ */
    @Input()
    fcIcon: string;
     /**å¾æ ä½ç½® */
    @Input()
    fcIconPositon: string;
     /**å è½½ä¸­*/
    @Input()
    fcLoading: string;
    _load:boolean;
     /**èæ¯éæ*/
    @Input()
    fcOpacity: string;
    _opacity:boolean;
     /**æ¯å¦ä¸ºåçº§*/
    @Input()
    fcBlock: string;
    _block:boolean;
     /**æç¤º*/
    @Input()
    fcToolTip: string;
     /**æ¾ç¤ºæ¨¡å¼*/
    @Input()
    fcMode: string;
     /**ä¸ææé®*/
    @Input()
    fcDropdown: Fcbtndropdown[];
     /**æé®ç»*/
    @Input()
    fcGroup: Sysappbuttons[];
     /**å¾æ ä½ç½® æ°å¢å±æ§  */
    @Input()
    fcIconPosition:string;
    params: any;
     /**æ¯å¦ç¦ç¨*/
    _disableds: any;
     /**æ¯å¦ç¦ç¨æé®ç»*/
    @Input()
    fcDisableds: string;
     /**æé®åäº¬é¢è²*/
    @Input()
    fcStyle:string;
     /**åä¸ªæé®ç¦ç¨*/
    fcDisabled :string;
    _disabled :boolean;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-button');
         /**é»è®¤åå®¹ä¸ºç©º*/
        if (this.fcLabel === undefined) {
            this.fcLabel = '';
        }
         /**é»è®¤ç±»åæªæé®*/
        if (this.fcType === undefined) {
            this.fcType = BTNTYPE.default;
        }
         /**é»è®¤èæ¯ä¸ä¸ºéæè²*/
        if (this.fcOpacity === undefined || 'N') {
            this._opacity = false;
        }
         /**é»è®¤ä¸ä¸ºåçº§åç´ */
        if (this.fcBlock === undefined || 'N') {
            this._block = false;
        }
         /**é»è®¤ä¸å è½½*/
        if (this.fcLoading === undefined || 'N') {
            this._load = false;
        }
         /**é»è®¤ä¸ææé®æªç©º*/
        if (this.fcDropdown === undefined) {
            this.fcDropdown = [];
        }
         /**é»è®¤æé®å¾æ å¨å·¦ä¾§*/
        if (this.fcIconPositon === 'left') {
            this.fcIconPositon = BTNPOSITION.left;
        } else if (this.fcIconPositon === 'right') {
            this.fcIconPositon = BTNPOSITION.right;
        }
         /**é»è®¤æé®ç»ä¸ºç©º*/
        if (this.fcGroup === undefined) {
            this.fcGroup = [];
        }
         /**é»è®¤åç¬æé®ä¸ç¦ç¨*/
        if(this.fcDisabled === undefined || 'N'){
            this._disabled = false;
        }
    }
    ngOnChanges(param): void {
        super.ngOnChanges(param);
        if (this.fcType !== BTNTYPE.primary && this.fcType !== BTNTYPE.default
            && this.fcType !== BTNTYPE.dashed && this.fcType !== BTNTYPE.danger) {
            this.logService.error("æé®ç±»åä¸åæ³");
        }
         /***/
        if (this.fcDropdown === undefined) {
            this.fcDropdown = [];
        }
         /** æé®ç»ä¸­çæä¸ªæé®ä¸ç­äºç©ºæ¶ */
        if (this.fcDisableds !== undefined) {
            this._disableds = {};
            this.processDisableds();
        }
         /**å è½½æªâYâæ¶å è½½å±å¯ç¨*/
        if (this.fcLoading === 'Y') {
            this._load = true;
        }else{
            this._load = false;
        }
         /**fcBlockä¸ºåçº§*/
        if (this.fcBlock === 'Y') {
            this._block = true;
        }else{
            this._block = false;
        }
         /**fcOpacityä¸ºâYâæ¶éæ*/
        if (this.fcOpacity === 'Y') {
            this._opacity = true;
        }else{
            this._opacity = false;
        }
         /**fcDisabledä¸ºYæ¶ä¸ºtrue*/
        if(this.fcDisabled === 'Y'){
            this._disabled = true;
        }else{
            this._disabled = false;
        }

       this.fcToolTip=this.fcToolTip||'';
    }
    /**
     * å¤çå¼åèä¼ å¥çåæ°ï¼å¤æ­æé®ç»çæ¯ä¸ªæé®æ¯å¦ä¸ºç¦ç¨
     */
    private processDisableds(): void {
        let disableds;
        try {
            disableds = JSON.parse(this.fcDisableds);
        } catch (error) { this.msgService.error('æ ¼å¼ä¸å¹é,è¯·éæ°è®¾ç½®å¯ç¨æé®å­ç¬¦ä¸²'); };
        if (disableds) {
            this.fcGroup.forEach(btn => {
                if (disableds[btn.BTNCODE]) {
                    this._disableds[btn.BTNCODE] = true;
                } else {
                    this._disableds[btn.BTNCODE] = false;
                }
            })
        }
    }

    /*
    ä¸ææé®æåºçäºä»¶
    */
    _dropdownClick(ev:FCEVENT){
        this.event('click',{event:ev})
    }
}
/**
 * æé®ç±»å
 */
export const BTNTYPE = {
    primary: 'primary',
    default: 'default',
    dashed: 'dashed',
    danger: 'danger'
}
/**
 * æé®å½¢ç¶
 */
export const BTNSHAPE = {
    circle: 'primary'
}
export const BTNPOSITION = {
    left: 'left',
    right: 'right'
}
export interface Fcbtndropdown {
    icon?: string;
    label?: string;
    event?: string;
    position?: string;
}